import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { npsSurveySchema } from "@libs/db-schemas";

import { HTTPStatusCode } from "../../types";
import { errorSchema } from "../../utils/errors";

const c = initContract();

export const npsSurveysContract = c.router({
  createNpsSurvey: {
    summary:
      "Record a patient's NPS survey response after they submit their applications",
    method: "POST",
    path: "/nps-surveys",
    body: z.object({
      score: z.number().int().min(0).max(10),
      feedback: z.string().optional(),
      hasAllowedSharing: z.boolean(),
      applicationIds: z.uuid().array().min(1),
    }),
    responses: {
      [HTTPStatusCode.CREATED]: npsSurveySchema,
      [HTTPStatusCode.BAD_REQUEST]: errorSchema,
      [HTTPStatusCode.UNAUTHORIZED]: errorSchema,
    },
  },
});
